import { z } from 'zod';
import { PortfolioEventCardModelSchema } from 'entities/portfolio-event';
import { GetPortfolioEventCardsByCategoryUidApiResponseSchema } from '../store';

export const createPortfolioEventCardsFromGetPortfolioEventCardsApiResponse = (
    (response: z.infer< typeof GetPortfolioEventCardsByCategoryUidApiResponseSchema>) => (
        response.data?.map(({
            name,
            description,
            images,
            category,
            slug,
        }) => (
            PortfolioEventCardModelSchema.parse({
                uid: slug,
                name,
                description,
                images: images?.map(({ url }) => ({
                    url,
                })),
                category: category && {
                    uid: category.slug,
                    name: category.name,
                    slug: category.slug,
                },
                slug,
            })
        ))
    )
);
